import { Injectable } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/functions';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertTemplateComponent } from '../../alert/alert-template.component';

@Injectable()
export class SendEmailService {

    constructor(private cloudFunctions: AngularFireFunctions) {
    }

    public sendEmail(subjectToSend: string, messageToSend: string, emailToSend: string): Promise<any> {
        return this.cloudFunctions.httpsCallable('sendEmail')({
          subject: subjectToSend,
          message: messageToSend,
          email: emailToSend
        }).toPromise();
      }
}
